import StyledDiv from 'components/StyledDiv';
import ImageCustom from 'components/ImageCustom';
import * as React from 'react';
export default {
  StyledDiv,
  ImageCustom,
  React
};